<template>
  <v-menu
    offset-y
    left
    open-on-hover
  >
    <v-btn flat
      slot="activator"
      style="min-width:0px;"
      :class="banner ? banner.type : ''"
    >
      <v-badge
        :value="fetching || unreadNotifications"
        :color="fetching ? '#00000077' : 'red'"
        top
        overlap
      >
        <template
          v-if="unreadNotifications > 0 || fetching"
          v-slot:badge
        >
          <span>
            <v-icon
              class="spin"
              v-if="fetching"
              size="17"
            >
              sync
            </v-icon>
            <span
              v-else
            >
              {{ unreadNotifications }}
            </span>
          </span>
        </template>
        <v-icon
          :class="unreadNotifications > 0 ? 'unread_bell' : ''"
        >
          {{ unreadNotifications > 0 ? 'notifications_active' : 'notifications_none' }}
        </v-icon>
      </v-badge>
    </v-btn>
    <div
      v-if="banner"
      :class="banner.type"
      style="color: white;padding: 10px 25px 10px 25px;max-width:400px;"
    >
      <div
        v-if="banner.icon"
        style="display:inline-block;padding: 0 20px 0 0;"
      >
        <v-icon
          dark
          size="32"
        >
          {{ banner.icon }}
        </v-icon>
      </div>
      <div
        style="display:inline-block;"
      >
        <b>{{ 'title' in banner ? banner.title : "Service Alert" }}</b><br />
        {{ 'message' in banner ? banner.message : "A service alert is active, and you may experience degraded performance. We're working to resolve the issues as soon as possible." }}
      </div>
      <div
        style="display:inline;float:right;"
      >
        <v-btn
          v-if="'action_button' in banner"
          small
          outline
          dark
          :href="banner.action_button.link"
        >
          {{ banner.action_button.text }}
        </v-btn>
      </div>
      <div
        style="clear:both;"
      ></div>
    </div>
    <v-card
      width="400"
      style="background:white;"
    >
      <div
        style="width:100%;padding:5px;padding-left:20px;padding-right:20px;text-align:center;font-size:12px;margin-bottom:15px;"
      >
        <router-link
          style="float:left;"
          :to="{ name: 'UserCurrentNotifications' }"
        >
          All Notifications
        </router-link>
        <a
          style="float:right;"
          v-on:click.stop.prevent="readAllNotifications()"
        >
          Mark All Read
        </a>
      </div>
      <div
        v-if="notifications.length === 0"
        style="text-align:center;padding: 50px;color:lightgrey;"
      >
        <v-icon
          v-if="hoverEgg"
          style="font-size:48px;"
          class="unread_bell"
          @mouseleave="hoverEgg=false"
        >
          notifications_active
        </v-icon>
        <v-icon
          v-show="!hoverEgg"
          style="font-size:48px;"
          class="hover_effect"
          @mouseover="hoverEgg=true"
        >
          notifications_none
        </v-icon>
        <br />
        <span>You have no unread notifications</span>
      </div>
      <div
        v-for="notif in notifications"
        :key="notif.id"
      >
        <div
          style="position:relative;width:100%;border-bottom:1px solid grey;padding:15px;"
          :class="{ unread: (notif.read_at === null) }"
        >
          <div
            @click="readAndGo(notif)"
            style="width:100%;height:100%;"
          >
            <v-icon
              v-if="notif.type == 'File Upload Notification'"
              left
              style="float:left;"
            >
              inbox
            </v-icon>
            <v-icon
              v-else-if="notif.type == 'Form Notification' || notif.type == 'Form Signature Notification'"
              left
              style="float:left;"
            >
              assignment
            </v-icon>
            <v-icon
              v-else-if="notif.type == 'Message from Client'"
              left
              style="float:left;"
            >
              forum
            </v-icon>
            <v-icon
              v-else
              left
              style="float:left;"
            >
              build
            </v-icon>
            <span style="display:block;font-weight:600;">{{ notif.message }}</span>
            <span style="display:block;font-size:12px;">{{ convertToLocal(notif.sent_at) }}</span>
          </div>
          <div
            v-if="!notif.read_at"
            class="readOnly"
            v-on:click.stop.prevent="read(notif)"
          >
            <v-icon
              color="grey"
              style="vertical-align:middle;"
            >
              archive
            </v-icon>
          </div>
        </div>
      </div>
    </v-card>
  </v-menu>
</template>

<script>
import api from '@/api'
import { mapMutations, mapGetters, mapActions, mapState } from 'vuex'

export default {
  name: 'Notifications',
  props: ['banner'],
  data () {
    return {
      fetching: false,
      notifications: [],
      fetchInterval: null,
      hoverEgg: false
    }
  },
  created () {
    this.fetch()
    this.fetchInterval = setInterval(() => {
      this.fetch()
    }, 180000)
  },
  computed: {
    ...mapGetters('notifications', [
      'unreadNotifications'
    ]),
  },
  methods: {
    ...mapMutations('notifications', [
      'setUnreadCount',
    ]),
    fetch () {
      this.notifications = []
      this.fetching = true
      api.users.notifications.getUnread()
        .then(notifications => {
          this.notifications = notifications.data
          this.setUnreadCount(notifications.unread_count)
          this.fetching = false
        })
    },
    readAndGo (notification) {
      this.fetching = true
      api.users.notifications.read(notification.id)
        .then(() => {
          if (notification.read_at === null) {
            this.setUnreadCount(this.unreadNotifications - 1)
          }
          notification.read_at = 'now'
          if (notification.userforms.length > 0) {
            this.$router.push({ name: 'UserForm', params: { id: notification.userforms[0] } })
          } else if (notification.contactfiles.length > 0) {
            this.$router.push({ name: 'Contact', params: { id: notification.contact } })
          } else if (notification.contact !== null) {
            this.$router.push({ name: 'Contact', params: { id: notification.contact } })
          } else {
            this.$router.push({ name: 'ReportList' })
          }
          this.fetching = false
        })
    },
    read (notification) {
      this.fetching = true
      api.users.notifications.read(notification.id)
        .then(() => {
          if (notification.read_at === null) {
            this.setUnreadCount(this.unreadNotifications - 1)
          }
          notification.read_at = 'now'
          this.fetching = false
        })
    },
    readAllNotifications () {
      this.fetching = true
      api.users.notifications.readAll()
        .then(() => {
          this.notifications = []
          this.setUnreadCount(0)
          this.fetching = false
        })
    }
  },
  beforeDestroy () {
    clearInterval(this.fetchInterval)
  }
}
</script>

<style>
.spin {
    -webkit-animation: spin 1000ms infinite linear;
    animation: spin 1000ms infinite linear;
}
@-webkit-keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}
@keyframes spin {
    0% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
    100% {
        -webkit-transform: rotate(359deg);
        transform: rotate(359deg);
    }
}

.unread {
  background-color: #FFF176;
}

.readOnly {
  position: absolute;
  right:0;
  top:0;
  bottom:0;
  width:45px;
  height:100%;
  padding-top:22.5px;
  padding-left:11.5px;
  z-index:999;
}

.readOnly:hover {
  background: rgba(0,0,0,0.2);
}

.readOnly:hover i {
  color: white !important;
}

@-webkit-keyframes ring {
    0% {
        -webkit-transform: rotate(35deg);
    }
    12.5% {
        -webkit-transform: rotate(-30deg);
    }
    25% {
        -webkit-transform: rotate(25deg);
    }
    37.5% {
        -webkit-transform: rotate(-20deg);
    }
    50% {
        -webkit-transform: rotate(15deg);
    }
    62.5% {
        -webkit-transform: rotate(-10deg);
    }
    75% {
        -webkit-transform: rotate(5deg);
    }
    100% {
        -webkit-transform: rotate(0deg);
    }
}

@keyframes ring {
    0% {
        -webkit-transform: rotate(35deg);
        transform: rotate(35deg);
    }
    12.5% {
        -webkit-transform: rotate(-30deg);
        transform: rotate(-30deg);
    }
    25% {
        -webkit-transform: rotate(25deg);
        transform: rotate(25deg);
    }
    37.5% {
        -webkit-transform: rotate(-20deg);
        transform: rotate(-20deg);
    }
    50% {
        -webkit-transform: rotate(15deg);
        transform: rotate(15deg);
    }
    62.5% {
        -webkit-transform: rotate(-10deg);
        transform: rotate(-10deg);
    }
    75% {
        -webkit-transform: rotate(5deg);
        transform: rotate(5deg);
    }
    100% {
        -webkit-transform: rotate(0deg);
        transform: rotate(0deg);
    }
}

.unread_bell {
  color: #FDD835 !important;
  -webkit-text-stroke: 2px black;
  -webkit-animation: ring 1.5s ease;
  animation: ring 1.5s ease;
}

</style>
